<template>
  <div>
    <navigation></navigation>
    <div class="container mx-auto px-4">
      <book-nav></book-nav>
      <!-- <div v-if="book && note">
          <router-link to="/">My Notebooks</router-link> > 
          <router-link :to="`/admin/books/${book.id}`">{{ book.name }}</router-link> > 
          {{ note.title }}
        </div> -->

      <!-- <h1 class="page-title">
          <span v-if="book && book.name">New {{ book.name }}</span>
          <span v-else>New Note</span>
        </h1> -->

      <admin-notes-resource v-if="user" action="update"></admin-notes-resource>
    </div>
  </div>
</template>
<script>
import Navigation from "../Navigation.vue";
import AdminNotesResource from "./AdminNotesResource.vue";
import BookNav from "./BookNav.vue";
export default {
  data() {
    return {
      autoSaveTimer: null
    };
  },
  props: ["create"],
  components: {
    Navigation,
    AdminNotesResource,
    BookNav
  },
  computed: {
    user() {
        return this.$store.state.notes.user;
    },
    book() {
      return this.$store.state.notes.book;
    },
    note() {
      return this.$store.state.notes.note;
    }
  }
};
</script>
<style lang="scss"></style>
